import React, { useState } from "react"
import { Button } from "react-aria-components"
import Collapsible from "../../../../lib/Collapsible"
import { formatAddressString } from "../../../../../helpers/StringHelper"
import IconChevronUp from "../../../../../assets/icons/icon-chevron-up-blue.svg"
import IconChevronDown from "../../../../../assets/icons/icon-chevron-down-blue.svg"
import { IAddress } from "../../../entityComponents/Form/components/FormAddress"

interface SidePanelAddressAccordionProps {
    title: string
    address: IAddress | null | undefined
}

export default function SidePanelAddressAccordion({ title, address }: SidePanelAddressAccordionProps) {
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false)

    if (!address) {
        return null
    }

    return (
        <div className="side-panel-table__wrapper margin__top--s">
            <div className="display--flex flex__direction--row justifyContent--space-between padding__right--xxs">
                <div className="display--flex flex__direction--row alignItems--center padding__left--xxs ">
                    <p className="small">{title}</p>
                </div>
                <Button 
                    className={"button button--with-icon alignSelf--baseline margin__right--xxs12"} 
                    onPress={() => setIsCollapsed(prev => !prev)}
                >
                    <img src={`${isCollapsed ? IconChevronDown : IconChevronUp}`}></img>
                </Button>
            </div>
            <Collapsible isCollapsed={isCollapsed}>
                <div className="side-panel__info-box">
                    <div className="side-panel__info">
                        <div>
                            <p className="small small--2 textWrap whitespace--pre-line">
                                {formatAddressString(address)}
                            </p>
                        </div>
                    </div>
                </div>
            </Collapsible>
        </div>
    )
}
